import differenceInMonths from "date-fns/differenceInMonths";
import LocaleContext from "components/i18n/LocaleContext";
import { useContext } from "react";

interface TotalRatingsLineProps {
  totalRatings: number;
  periodStart: Date;
  periodEnd: Date;
}

function TotalRatingsLine({ totalRatings, periodEnd, periodStart }: TotalRatingsLineProps) {
  const diffInMonths = differenceInMonths(periodEnd, periodStart);
  const locale = useContext(LocaleContext);

  if (locale === "BRA") {
    return (
      <p className="whitespace-nowrap text-sm font-medium tracking-wide text-slate-500 dark:text-slate-400">
        <strong>{totalRatings}</strong> {totalRatings === 1 ? "voto" : "votos"} nos últimos{" "}
        <strong>{diffInMonths}</strong> meses
      </p>
    );
  }

  return (
    <p className="text-sm font-medium tracking-wide text-slate-500 dark:text-slate-400">
      <strong>{totalRatings}</strong> {totalRatings === 1 ? "rating" : "ratings"} in the last{" "}
      <strong>{diffInMonths}</strong> months
    </p>
  );
}

export default TotalRatingsLine;
